import decoder from '../../../lib/decoder';
import ModelNumber from './number'
import ModelPageNav from './page_nav'
import ModelTariff from './tariff'
import ModelProvider from './provider'
import ModelDiscount from './discount'

function ModelNumberGroup() {
	this.id = '';
	this.code = 0;
	this.tariffId = 0;
	this.branchId = 0;
	this.priceOnce = 0;
	this.priceOnceFull = 0;
	this.priceMonthly = 0;
	this.priceMonthlyFull = 0;
	this.discount = null;
	this.isUpsale = false;
	this.items = null;
	this.itemsById = {};
	this.nav = null;
	this.tariffs = null;
	this.provider = null;
	this.selectedTariff = null;
}

ModelNumberGroup.prototype.is8800 = function () {
	return this.code === 800;
};

ModelNumberGroup.prototype.append = function (group) {
	if (Array.isArray(group.items)) {
		group.items.forEach(item => {
			this.items.push(item);
			this.itemsById[item.id] = item;
		})
	}
	if (group.nav) {
		this.nav.page = group.nav.page;
	}
};

ModelNumberGroup.prototype.fillSelectedTariffs = function (cart) {
	if (this.provider) {
		let tariffs = cart.getSelectedTariffsByProvider();
		let tariff = tariffs[this.provider.id];
		if (tariff) {
			this.selectedTariff = tariff;
		}
	}
};

ModelNumberGroup.prototype.fillSelectedNumbers = function (cart) {
	if (Array.isArray(this.items)) {
		let numbersIdInCart = cart.getSelectedNumbersById();
		this.items.forEach((item) => {
			if (numbersIdInCart[item.id] === true) {
				if (!item.selected) {
					item.selected = true;
				}
			} else {
				if (item.selected) {
					item.selected = false;
				}
			}
		});
	}
};

ModelNumberGroup.prototype.toggleNumberSelected = function (numbersId, isSelected) {
	if (!Array.isArray(numbersId)) {
		if (parseInt(numbersId) > 0) {
			numbersId = [numbersId];
		}
	}
	if (Array.isArray(numbersId)) {
		numbersId.forEach(id => {
			if (Object.hasOwnProperty.call(this.itemsById, id)) {
				let item = this.itemsById[id];
				if (item.selected !== isSelected) {
					item.selected = isSelected;
				}
			}
		})
	}
};

ModelNumberGroup.prototype.toggleNumberError = function (numbersId, hasError) {
	if (!Array.isArray(numbersId)) {
		if (parseInt(numbersId) > 0) {
			numbersId = [numbersId];
		}
	}
	if (Array.isArray(numbersId)) {
		numbersId.forEach(id => {
			if (Object.hasOwnProperty.call(this.itemsById, id)) {
				let item = this.itemsById[id];
				if (item.error !== hasError) {
					item.error = hasError;
				}
			}
		})
	}
};

ModelNumberGroup.create = function (json, cart) {
	if (!json) json = {};
	
	let model = new ModelNumberGroup();
	
	model.id = decoder.stringValue(json['block_id'], '');
	model.code = decoder.intValue(json['code'], 0);
	model.tariffId = decoder.intValue(json['tariff_id'], 0);
	model.branchId = decoder.intValue(json['branch_id'], 0);
	model.priceOnce = decoder.floatValue(json['price_inst'], 0);
	model.priceOnceFull = decoder.floatValue(json['price_inst_old'], 0);
	model.category = decoder.stringValue(json['beauty_code'], '');

	if (model.priceOnceFull < model.priceOnce) {
		model.priceOnceFull = model.priceOnce;
	}

	model.priceMonthly = decoder.floatValue(json['price_abon'], 0);
	model.priceMonthlyFull = decoder.floatValue(json['price_abon_old'], 0);
	if (model.priceMonthlyFull < model.priceMonthly) {
		model.priceMonthlyFull = model.priceMonthly;
	}

	model.discount = decoder.decode(ModelDiscount, json['discount']);
	model.isUpsale = decoder.boolValue(json['is_upsale'], false);
	model.items = decoder.decode(ModelNumber, json['items']);

	if (Array.isArray(model.items)) {
		model.items.forEach(item => {
			model.itemsById[item.id] = item;
		});
	}

	model.nav = decoder.decode(ModelPageNav, json['nav']);
	model.tariffs = decoder.decode(ModelTariff, json['tariffs']);
	model.provider = decoder.decode(ModelProvider, json['provider']);
	
	if (cart) {
		model.fillSelectedTariffs(cart);
		model.fillSelectedNumbers(cart);
	}
	
	return model;
};

export default ModelNumberGroup;